import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  height: 14px;
  margin-bottom: 5px;
  margin-right: 7.5px;
`

const Icon = styled.svg`
  display: block;
  fill: none;
  stroke: white;
  stroke-width: 4px;
  margin-left:1px;
  margin-top: 1px;
`
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const StyledCheckbox = styled.div`
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 1px;
  transition: all 150ms;
  border: 1.8px solid #FFFFFF;

  ${Icon} {
    visibility: ${(props) => (props.checked ? 'visible' : 'hidden')}
  }
`

const Checkbox = ({ className, checked, checkboxBg, ...props }) => (
    <CheckboxContainer className={className}>
        <HiddenCheckbox checked={checked} {...props} />
        <StyledCheckbox checked={checked} className={checkboxBg ? checkboxBg : "background-primary"}>
            <Icon viewBox="0 0 26 26">
                <polyline points="20 6 9 17 4 12" />
            </Icon>
        </StyledCheckbox>
    </CheckboxContainer>
)

Checkbox.propTypes = {
    className: PropTypes.string,
    checked: PropTypes.bool,
    checkboxBg: PropTypes.string,
}

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/UI/Checkbox.jsx